import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import AppBar from "@material-ui/core/AppBar";
import Toolbar from "@material-ui/core/Toolbar";
import IconButton from "@material-ui/core/IconButton";
import MenuIcon from "@material-ui/icons/Menu";
import logo from "src/assets/SHARMBLE-LOGO-40x40.svg";
import { useLayoutContext } from "./LayoutContext";

const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
  },
  title: {
    flexGrow: 1,
    position: "absolute",
    left: "calc(50% - 18px)",
    width: 36,
    height: 36,
  },
  toolbar: {
    position: "relative",
  },
}));

export default function ButtonAppBar() {
  const classes = useStyles();
  const { switchDrawer } = useLayoutContext();

  return (
    <div className={classes.root}>
      <AppBar position="static" color="secondary">
        <Toolbar className={classes.toolbar}>
          <IconButton edge="start" color="inherit" onClick={switchDrawer}>
            <MenuIcon />
          </IconButton>
          <img alt="logo" src={logo} className={classes.title} />
        </Toolbar>
      </AppBar>
    </div>
  );
}
